import { render } from "./GroupItem.vue?vue&type=template&id=764aca4e&ts=true"
import script from "./GroupItem.vue?vue&type=script&lang=ts"
export * from "./GroupItem.vue?vue&type=script&lang=ts"

import "./GroupItem.vue?vue&type=style&index=0&id=764aca4e&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__